function localize (obj) {
    if (typeof obj === 'object') {
        return obj[window.App.page.lang]
    }
}

export { localize }
